/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styled from "styled-components";

const CourseInfo = ({type,course}) => {

  const courses = {
    'frontend' : {
      "react" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering ReactJS for Modern Web Development",
        description: "ReactJS is a popular JavaScript library developed by Facebook for building user interfaces, especially single-page applications. It enables developers to create reusable UI components that manage their own state, making it easier to build complex and interactive UIs. React uses a virtual DOM to efficiently update and render components, ensuring high performance. It's widely used for front-end development due to its flexibility and ease of integration with other libraries and frameworks.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "javascript" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering JavaScript for Interactive Web Development",
        description: "Welcome to the Comprehensive JavaScript Mastery course! This course is designed to take you from a beginner to an advanced level in JavaScript programming. Whether you're completely new to coding or looking to deepen your understanding of JavaScript, this course will provide you with the necessary knowledge and skills to become proficient in one of the most widely used programming languages in the world.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "jquery" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/9c20afe8f03bf41781ded8405d2f6918ebadaeb65a5b0936c9064a44904047e7?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering jQuery for Interactive Web Development",
        description: "This course will teach you how to use jQuery, a fast, small, and feature-rich JavaScript library. You will learn how to simplify the client-side scripting of HTML, enhance your web pages with dynamic features, and create interactive, user-friendly interfaces.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      }
    },
    'backend' : {
      "java" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering Java Programming: From Basics to Advanced Concepts",
        description: `Unlock the full potential of Java with this comprehensive course designed for both beginners and experienced developers. Start by mastering the fundamentals of Java programming, including syntax, data types, and control structures. Progress to advanced topics such as object-oriented programming, multithreading, and network programming.
        Gain hands-on experience with practical exercises, including building applications, handling exceptions, working with databases, and implementing concurrency. Learn best practices and design patterns to write clean, efficient code. Complete the course by developing a comprehensive Java project that demonstrates your new skills and prepares you for real-world challenges.`,
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "nodejs" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering Node.js: From Basics to Advanced",
        description: "This comprehensive Node.js course takes you from foundational concepts to advanced techniques in building server-side applications. You will explore Node.js core modules, asynchronous programming, web development with Express, real-time communication with WebSocket, and best practices for optimizing and deploying Node.js applications.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "springboot" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/9c20afe8f03bf41781ded8405d2f6918ebadaeb65a5b0936c9064a44904047e7?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering Spring Boot: From Fundamentals to Advanced",
        description: "This comprehensive course will guide you through the fundamentals of Spring Boot, a powerful framework for building Java-based enterprise applications. You will learn to develop scalable, secure, and efficient web applications by understanding core concepts, advanced features, and best practices in Spring Boot. Through hands-on exercises and real-world projects, you'll gain the practical experience needed to leverage Spring Boot effectively in your development workflow.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      }
    },
    'database' : {
      "mysql" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering MySQL: From Fundamentals to Advanced Database Management",
        description: `This comprehensive course is designed to take you from the basics of MySQL to advanced database management techniques. You’ll learn how to design, implement, and manage databases efficiently, ensuring high performance and scalability. The course covers SQL querying, database design principles, optimization strategies, and real-world use cases to equip you with the skills necessary for managing complex databases in various environments.`,
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "mongodb" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering MongoDB: From Fundamentals to Advanced Features",
        description: "This comprehensive course is designed to take you from the basics to the advanced features of MongoDB, one of the leading NoSQL databases. You'll start with understanding the core concepts of MongoDB and NoSQL, and then move on to mastering CRUD operations, schema design, and query optimization. As you progress, you'll dive into more complex topics such as aggregation pipelines, replication, sharding, and security. The course also covers essential practices for backup, recovery, and performance tuning, as well as advanced features like geospatial queries, full-text search, and transactions. By the end of this course, you'll be equipped with the knowledge and skills to effectively design, implement, and manage MongoDB databases in real-world applications.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      }
    },
    'ui_ux' : {
      "figma" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Design Mastery with Figma: From Basics to Advanced Techniques",
        description: "This course is designed for aspiring designers and design professionals who want to master Figma, a powerful and collaborative design tool. Starting with the fundamentals, you will learn how to navigate Figma's interface, create and manage design projects, and utilize Figma’s features for both UI/UX and graphic design. The course progresses through more advanced topics, including prototyping, design systems, and collaborative workflows. By the end of the course, you'll be proficient in creating sophisticated designs, collaborating effectively with team members, and implementing design best practices using Figma.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "html" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering HTML: From Basics to Advanced",
        description: "This course provides a comprehensive introduction to HTML, the cornerstone of web development. You'll learn to create well-structured web pages, understand HTML5 elements, and apply best practices for web development. By the end of the course, you'll be able to build accessible, responsive, and semantically correct web pages.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "css" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/9c20afe8f03bf41781ded8405d2f6918ebadaeb65a5b0936c9064a44904047e7?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Mastering CSS for Modern Web Design",
        description: "This course provides a thorough understanding of CSS, focusing on styling and designing modern web interfaces. You'll learn CSS fundamentals, advanced styling techniques, responsive design principles, and best practices for creating visually appealing and accessible websites.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      }
    },
    'others' : {
      "dsa" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/c50619eaecb6ea80d38d5e33f0271d68ba1f06c77031b21b7d08664c64c3c455?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Data Structures and Algorithms",
        description: "This course provides an in-depth understanding of data structures and algorithms, essential for problem-solving in computer science. It covers foundational concepts, advanced data structures, and algorithmic techniques with hands-on exercises and real-world applications.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "asd" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/510622f50ff15446a7314b66bf2dd6ff555efd04a575154550b38d317f46f3f4?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Advance System Design",
        description: "This course provides a deep dive into system design principles and practices, essential for building scalable and efficient systems. It covers core concepts, architectural patterns, and real-world applications with hands-on exercises to enhance problem-solving skills in system design.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      },
      "aip" : {
        imageSrc : "https://cdn.builder.io/api/v1/image/assets/TEMP/2fd32f4ac4b13c496e37b7a961c891720de8bd47ba57740f318a3de28bb64351?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        image:
          "https://cdn.builder.io/api/v1/image/assets/TEMP/9c20afe8f03bf41781ded8405d2f6918ebadaeb65a5b0936c9064a44904047e7?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a",
        title: "Best Job Interview Practices",
        description: "This course equips you with essential skills and techniques for excelling in job interviews. It covers interview preparation, effective communication, and strategies for tackling common interview questions, including behavioral and technical questions. Participants will engage in practical exercises to refine their interview skills and build confidence.",
        startDate: "August 15",
        learners: 12345,
        averageRating: 5.5,
        reviewsCount: "5k",
      }
    }
  };

  return (
    <StyledCourseInfo>
      <CourseHeader>
        <CourseTitle>{courses[type][course].title}</CourseTitle>
        <CourseImage loading="lazy" src={courses[type][course].imageSrc} alt={courses[type][course]} />
      </CourseHeader>
      {/* <div className="course-stats">
        <div className="learners">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/92d6ee79ab0e59090966d4d50558633fb265f05138614d1a872e1042ee4b3059?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a"
            alt="Learners icon"
          />
          <span>
            12345 <span className="text-muted">learners</span>
          </span>
        </div>
        <div className="divider"></div>
        <div className="rating">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/37740681dc378690c3a318792021f8bd3dba595b7e4a191277a84650ffeca608?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a"
            alt="Star icon"
          />
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/14cceaecfd5676f7542eb0bd2eb55a33c4d1357cad487783647bb57f968c7845?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a"
            alt="Star icon"
          />
          <span>5.5</span>
          <span className="reviews">(5k reviews)</span>
        </div>
      </div> */}
      <div className="course-preview">
        <div className="video-preview">
          <img
            src={courses[type][course].image}
            alt="Course preview"
          />
          {/* <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/bbc9171e0e967933c681a98472bacf87323856d7805a733e270ae71cf34d9874?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a"
            alt="Play button"
            className="play-button"
          /> */}
        </div>
        <div className="course-description">
          <p>
            {
              courses[type][course].description
            }
          </p>
          {/* <div className="start-date">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/ea89a4cc63b24c68428707c42bdf57259eb1e305e8e0541d83ab1ce74ef8ff54?apiKey=a6dad463439244ae86e3212633b4369a&&apiKey=a6dad463439244ae86e3212633b4369a"
              alt="Calendar icon"
            />
            <span>
              Online classes starts on <strong>August 15</strong>
            </span>
          </div> */}
          <div className="cta-buttons">
            {/* <button className="enroll-btn">Enroll now</button> */}
            <button className="curriculum-btn">Download Curriculum</button>
          </div>
        </div>
      </div>
    </StyledCourseInfo>
  );
};

const CourseHeader = styled.div`
  display: flex;
  gap: 12px;
  @media (max-width: 991px) {
    margin-left: 10px;
  }
  margin-top: 45px;
  white-space: nowrap;
  position: relative;
  bottom: 15px;
`;

const CourseTitle = styled.h2`
  color: rgba(52, 64, 84, 1);
  font: 500 20px Encode Sans Semi Condensed, -apple-system, Roboto, Helvetica,
    sans-serif;
`;

const CourseImage = styled.img`
  aspect-ratio: 1;
  width: 24px;
  position:relative;
  bottom:2px;
`;

const StyledCourseInfo = styled.section`
  
  padding: 0px 106px;

  @media (max-width: 991px) {
    padding: 0px 0px;
  }

  h1 {
    color: #101828;
    font: 600 30px "Encode Sans Semi Condensed", sans-serif;
    margin: 21px 101px;
  }

  .course-stats {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    font-family: Inter, sans-serif;
    margin-bottom: 34px;

    .learners,
    .rating {
      display: flex;
      align-items: center;
      gap: 11px;
      font-size: 15px;
      color: #7f56d9;
      font-weight: 500;
    }

    .divider {
      width: 1px;
      height: 26px;
      background-color: rgba(52, 64, 84, 0.48);
    }

    .text-muted,
    .reviews {
      color: #344054;
    }
  }

  .course-preview {
    display: flex;
    gap: 20px;
    @media (max-width: 991px) {
      margin-left: 10px;
      padding-right:10px;
    }

    .video-preview {
      position: relative;
      width: 42%;

      img {
        width: 100%;
        height: auto;
      }

      .play-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 65px;
        height: 65px;
      }
    }

    .course-description {
      width: 58%;

      p {
        color: #344054;
        font: 400 16px Inter, sans-serif;
        margin-top: 41px;
      }

      .start-date {
        display: flex;
        align-items: center;
        gap: 6px;
        color: #072c50;
        margin-bottom: 10px;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .cta-buttons {
        display: flex;
        gap: 19px;
        position: relative;
        left: 203px;
        @media (max-width: 991px) {
          left: 77px;
        }

        button {
          padding: 10px 18px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
        }

        .enroll-btn {
          background-color: #7f56d9;
          color: white;
          border: none;
        }

        .curriculum-btn {
          background-color: white;
          color: #344054;
          border: 1px solid #d0d5dd;
        }
      }
    }
  }

  @media (max-width: 991px) {
    .course-preview {
      flex-direction: column;

      .video-preview,
      .course-description {
        width: 100%;
      }
    }
  }
`;

export default CourseInfo;
